module.exports = __webpack_public_path__ + "static/img/战略级场景_角标_image@2x.c1abe234.png";